// BNB Address
const BNB_ADDRESS = '0xa26dfBF98Dd1A32FAe56A3D2B2D60A8a41b0bDF0'

export { BNB_ADDRESS }
